// @flow
import client from '../../client'
import { config } from '../../config'
import prebookSearchTripBuilder from './builders/prebookSearchTrip'
import format from '../../utils/format'
import poller from '../../utils/poller'
import { filterSearchQuery, isMoreComing, isResultEmpty } from './utils'

// Types
import type { Trip } from '../../models/trip'
import type { PrebookSearchResponse } from '../../api_types'

export type Options = {
  session_id: string,
  trip_id: string,
  params: Object, // FIXME
}

// API Endpoints
export const RETURN_TRIP_ENDPOINT = '/search/return_trip/{0}/{1}/'
export const PREBOOK_POOL_ENDPOINT = '/search/{0}/poll/'

/**
 * By given search id and result id returns a new result only
 * with one trip to be used as round trip.
 * @param {Object} data              Request data
 * @param {string} data.session_id   Id of the search
 * @param {string} data.trip_id      Id of the trip from given search
 * @param {Object} data.params       Payload data for the API. Should contain
 *                                   `pickup_datetime` or `flight_datetime`
 * @return {Promise}                 Promise will be resolved with the trip object
 *                                   or with null if something went wrong.
 */
export const getReturnTrip = (data: Options): Promise<?Trip> => {
  const { session_id, trip_id } = data || {}
  const initPollEndpoint = format(RETURN_TRIP_ENDPOINT, session_id, trip_id)
  const query = filterSearchQuery(data.params)

  return poller({
    initPoll: () =>
      client.post(initPollEndpoint, {
        body: query,
        baseUrl: config.BASE_URL_SEARCH,
      }),
    pollNext: (id) =>
      client.get(format(PREBOOK_POOL_ENDPOINT, id), {
        baseUrl: config.BASE_URL_SEARCH,
      }),
    builder: (response: PrebookSearchResponse) =>
      prebookSearchTripBuilder(response.results[0], response),
    isMoreComing,
    isResultEmpty,
    pollAll: true,
  })().then((results) => (results && results.length > 0 ? results[0] : null))
}

export default getReturnTrip
